export class BatchMark {
    constructor() {
        this.updateMark = -1;
        this.indexInList = -1;
        this.batched = false;
        this._curBindElementIndex = 0;
        this._cacheRenderElement = [];
    }
}
